import styled from "@emotion/styled";
import { danger, neutralDark20 } from "../../../constants/colors";
import { RequiredThemeKeys } from "../../../util/theme";
import { TypeRampV2 } from "../../typography";
import { FormLabelValidationState } from "../types";
import { formLabelColorTheme } from "./formLabelColorTheme";

interface FormLabelValidationProps {
    themeMode: RequiredThemeKeys;
    validationState: FormLabelValidationState;
}

export const FormLabelValidation = styled(TypeRampV2)<FormLabelValidationProps>`
    font-weight: 400;
    margin-top: 1px;
    color: ${({ validationState }) => (validationState === "error" ? danger : neutralDark20)};
    color: ${({ themeMode, validationState }) => formLabelColorTheme.color[validationState](themeMode)};
`;
